import React from 'react';
import {
    Platform,
    StyleSheet,
    Text,
    View,
    ScrollView,
    TouchableOpacity,
    Alert,
    KeyboardAvoidingView,
    Image, BackHandler
} from 'react-native';
import {styles, trackMarkStyles} from "./styles"
import HMTextView from "../HMTextView";
import Colors from "../../tools/Colors";
import {moderateScale} from "../../tools/Scaling";

const DEFAULT_VALUE = 0.2;


function SliderContainer(props: {
    caption: string,
    children: React.Node,
    sliderValue?: Array<number>,
    trackMarks?: Array<number>,
}) {
    const {caption, sliderValue, trackMarks, type} = props;
    let unit = (type === "price" ? " تومان " : "");
    const [value, setValue] = React.useState(
        sliderValue ? sliderValue : DEFAULT_VALUE,
    );

    let renderTrackMarkComponent;
    if (trackMarks?.length) {
        renderTrackMarkComponent = (index: number) => {
            const currentMarkValue = trackMarks[index];
            const style =
                currentMarkValue > Math.max(value)
                    ? trackMarkStyles.activeMark
                    : trackMarkStyles.inactiveMark;
            return <View style={style}/>;
        };
    }

    const renderChildren = () => {
        return React.Children.map(props.children, (child) => {
            //  if (!!child && child.type === Slider) {
            if (!!child) {
                return React.cloneElement(child, {
                    onValueChange: setValue,
                    renderTrackMarkComponent,
                    trackMarks,
                    value,
                });
            }
            return child;
        });
    };

    return (
        <View style={styles.sliderContainer}>
            <View style={styles.titleContainer}>
                <View style={{width: moderateScale(80), alignItems: "center", justifyContent: "center"}}>
                    <HMTextView
                        type={"bold"}

                        style={[
                            {
                                // position: 'absolute',
                                //  bottom: 0,
                                // height: moderateScale(44),
                                // width: '100%',
                                textAlign: "center",
                                color: Colors.blackLight,
                                fontSize: moderateScale(11),
                                //  padding: moderateScale(1),

                                // backgroundColor: 'rgba(0,0,0,0.25)',
                            }]}
                        numberOfLines={1}
                        text={caption}
                    />
                    <View style={{width: moderateScale(4)}}/>

                </View>
                {/*<Text>{caption}</Text>*/}
                {/*<Text>{Array.isArray(value) ? value.join(' - ') : value}</Text>*/}
                <View style={{flex: 1}}>
                    {renderChildren()}
                    <View style={{flexDirection: "row", justifyContent: "center"}}>
                        <HMTextView
                            type={"bold"}

                            style={[
                                {
                                    // position: 'absolute',
                                    //  bottom: 0,
                                    // height: moderateScale(44),
                                    // width: '100%',
                                    textAlign: "center",
                                    color: Colors.blackLight,
                                    fontSize: moderateScale(11),
                                    //  padding: moderateScale(1),

                                    // backgroundColor: 'rgba(0,0,0,0.25)',
                                }]}
                            numberOfLines={1}
                            //  text={Array.isArray(value) ? value.join(' - ') : value}
                            text={` ( ${value[1]} - ${value[0]} )  `}
                            styleRoot={{alignSelf: "center"}}
                        />
                        <HMTextView
                            type={"bold"}

                            style={[
                                {
                                    // position: 'absolute',
                                    //  bottom: 0,
                                    // height: moderateScale(44),
                                    // width: '100%',
                                    textAlign: "center",
                                    color: Colors.blackLight,
                                    fontSize: moderateScale(11),
                                    marginHorizontal: moderateScale(2)
                                    //  padding: moderateScale(1),

                                    // backgroundColor: 'rgba(0,0,0,0.25)',
                                }]}
                            numberOfLines={1}
                            //  text={Array.isArray(value) ? value.join(' - ') : value}
                            text={unit}
                            styleRoot={{alignSelf: "center"}}
                        />
                    </View>
                </View>
            </View>

        </View>
    );
};


export default SliderContainer
